import React from 'react';

function Text({ data }) {
    return <p className="body2">{data}</p>;
}

export default React.memo(Text);
